import React from "react";

import { getColorFromName, getInitials } from "../../../../../helper/avatarHelper";

interface EmployeeAvatarProps {
  name: string;
  image?: string | null;
  size?: number;
}

export const EmployeeAvatar: React.FC<EmployeeAvatarProps> = ({
  name,
  image,
  size = 36,
}) => {
  const initials = getInitials(name || "");
  const bgColor = getColorFromName(name || "");
  return (
    <div
      className="border avatar-rounded position-relative overflow-hidden flex-shrink-0"
      style={{ width: size, height: size, borderRadius: "50%" }}
    >
      <div
        className="d-flex align-items-center justify-content-center w-100 h-100"
        style={{
          backgroundColor: bgColor,
          color: "white",
          fontSize: size * 0.36,
          fontWeight: 600,
        }}
      >
        {initials}
      </div>
      {image ? (
        <img
          src={image}
          alt={name}
          className="position-absolute top-0 start-0"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      ) : null}
    </div>
  );
};

export default EmployeeAvatar;
